import React, { FC, useState } from "react";
import cx from "classnames";
import { useTranslation } from "i18n";
import { dataTestIds } from "data-testids";
import TagminLogo from "component-library/src/images/tagmin/tagmin-logo.png";
import { ReactComponent as ChevronDown } from "component-library/src/images/svg/icons/chevrondown.svg";
import TagminCalendarIcon from "component-library/src/images/tagmin/tagmin-availability-calendar.png";
import { IAvailabilityCalendar } from "models/suggestion";
import CalendarRecord from "./CalendarRecord";

interface Props {
  tagminAvailability: IAvailabilityCalendar;
}

const TagminAvailabilityCalendar: FC<React.PropsWithChildren<Props>> = ({
  tagminAvailability,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="max-h-[180px] rounded-b-[4px] flex flex-col">
      <button
        className={cx(
          "min-h-[36px] w-full bg-color-neutral-three px-[10px] py-[5px] flex items-center gap-1",
          { "rounded-b-[4px]": !isOpen }
        )}
        onClick={handleOpen}
        data-testid={
          dataTestIds.nuJobsApp[
            "MakeSuggestionsView.Card.TagminAvailabilityCalendar.TagminAvailabilityCalendar.handleOpen"
          ]
        }
      >
        <img
          src={TagminCalendarIcon}
          alt={t("agent:tagminAvailabilityCalendar.alt.calendar")}
          className="h-4"
        />
        <img
          src={TagminLogo}
          alt={t("agent:tagminAvailabilityCalendar.alt.logo")}
          className="h-[19px]"
        />
        <ChevronDown
          width={20}
          height={20}
          className={cx("ml-auto", { "rotate-180": isOpen })}
        />
      </button>
      {isOpen && (
        <div className="overflow-auto rounded-b-[4px]">
          {tagminAvailability.map((record) => (
            <CalendarRecord record={record} key={record.externalId} />
          ))}
          <div className="w-full text-[10px] bg-color-neutral-three  text-center rounded-b-[4px]">
            {t("agent:tagminAvailabilityCalendar.limitDescr")}
          </div>
        </div>
      )}
    </div>
  );
};

export default TagminAvailabilityCalendar;
